import React from 'react';

const Spinner = ({ size = 24, label, block }) => {
    const node = (
        <span className="fs-spinner">
            <span
                className="fs-spinner-mark"
                style={{ width: size, height: size }}
                aria-hidden="true"
            >
                <span className="ink" />
                <span className="acc" />
            </span>
            {label ? <span className="fs-spinner-label">{label}</span> : null}
        </span>
    );

    if (block) {
        return (
            <div className="fs-spinner-block" role="status" aria-live="polite">
                {node}
            </div>
        );
    }
    return <span role="status">{node}</span>;
};

export default Spinner;
